import { useDispatch, useSelector } from 'react-redux';
import { selectSchema } from '../store/selectors';
import { isCWTSchemaList, isCWTSchemaSection, isCWTSchemaSectionGroup, isCWTSchemaTable, sortByOrder } from '../store/utils';
import { addProperty } from '../store/slice';
import ActionButtons from './ActionButtons';
import TopActions from './TopActions';
import SectionGroup from './components/SectionGroup';
import List from './components/List';
import Section from './components/Section';
import SidePanel from './side-panel/SidePanel';
import Table from './components/Table';
import EmptyForm from './EmptyForm';
import Field from './components/field/Field';

type CWTFormProps = {
    templateName: string;
};

function CWTForm({ templateName }: CWTFormProps): JSX.Element {
    const dispatch = useDispatch();

    const schema = useSelector(selectSchema);

    if (!schema || !schema.properties) {
        return (
            <div>
                <p>Unable to load schema. Please reload the page.</p>
            </div>
        );
    }

    function addNewProperty(type: 'LIST' | 'SECTION_GROUP' | 'SECTION' | 'FIELD' | 'TABLE'): void {
        dispatch(addProperty({ type }));
    }

    return (
        <div className="flex gap-8 w-full">
            <div className="flex flex-col items-center gap-8 grow">
                <TopActions onAdd={addNewProperty} />
                {Object.keys(schema.properties).length === 0 ? (
                    <div className="mt-8">
                        <EmptyForm onAdd={addNewProperty} templateName={templateName} />
                    </div>
                ) : (
                    <>
                        {sortByOrder(schema.properties).map((value) => {
                            const property = value;

                            if (isCWTSchemaSectionGroup(property)) {
                                return <SectionGroup key={property.id} sectionGroup={property} />;
                            }

                            if (isCWTSchemaSection(property)) {
                                return <Section key={property.id} section={property} />;
                            }

                            if (isCWTSchemaTable(property)) {
                                return <Table key={property.id} table={property} />;
                            }

                            if (isCWTSchemaList(property)) {
                                return <List key={property.id} list={property} />;
                            }

                            return (
                                <div key={property.id} className="border w-full rounded-lg border-gray-300">
                                    <Field field={property} />
                                </div>
                            );
                        })}

                        <ActionButtons onAdd={addNewProperty} />
                    </>
                )}
            </div>
            <SidePanel />
        </div>
    );
}

export default CWTForm;
